// היום שלי — the landing page: everything today holds, in one place. Owns the top-level
// `myDay` key and nothing else, including its own nav label, so no other area ever has to
// open this file and this one never has to open theirs.
//
// IT PHRASES ITS OWN WORDS, even where another area says the same thing. 'באיחור' appears
// here as well as in alerts.js, money.js and dashboard.js — each area labels its own
// screen, which is what keeps the parts independent. The one exception is the task row's
// "go to" link, which is printed by utils/boardLink beside the path it names and therefore
// has to be phrased with it (see he.alerts.goBoard).
//
// Pure data — no imports, ever. See he.js.
const myDay = {
  myDay: {
    nav: 'היום שלי',
    title: 'היום שלי',

    // The both/mine filter. Every source on this page knows its own owner — a task its
    // assignee, a follow-up its lead's owner, a meeting BOTH its sides — so narrowing is
    // one question asked of three lists.
    all: 'של שנינו',
    mine: 'שלי',

    // ── The sections ───────────────────────────────────────────────────────────────
    // The order is the day's own: where I have to BE, then what I have to produce, then
    // who is waiting to hear from me, then the money — which is a link, not a list.
    sectionMeetings: 'פגישות היום',
    sectionTasks: 'משימות',
    sectionLeads: 'לידים לחזרה',

    // The two states inside a section. A task carried over from last week is not
    // scheduled for today and must not read as though it were, so it gets its own
    // heading rather than a colour inside one list.
    groupLate: 'באיחור',
    groupToday: 'להיום',

    // Row badges — the same two states, said on the row itself.
    late: 'באיחור',
    dueToday: 'להיום',

    // ── Meetings ───────────────────────────────────────────────────────────────────
    // A meeting is neither late nor on time: it is at a time. What its row reports is
    // what became of it.
    meetingCancelled: 'מבוטלת',
    meetingHeld: 'התקיימה',
    meetingInternal: 'פגישה פנימית',
    goCalendar: 'ליומן',

    // ── Leads ──────────────────────────────────────────────────────────────────────
    lastContact: 'שיחה אחרונה',
    noContactYet: 'עדיין לא תועדה שיחה',
    goLead: 'למסך הלידים',

    // ── Tasks ──────────────────────────────────────────────────────────────────────
    // The orphan case, carried over from the bell because this page reads the same rows:
    // a task on a ליד אבוד or on a deactivated client is on no list, so the row says so
    // instead of looking ordinary while its link goes somewhere unexpected.
    noBoard: 'לא מופיעה בשום לוח',
    noBoardHint: 'הלקוח אינו לקוח פעיל ואינו ליד בתהליך, ולכן המשימה מופיעה רק כאן, בפעמון ובכרטיס הלקוח.',

    // ── The money strip ────────────────────────────────────────────────────────────
    // ONE LINE, NEVER A LIST. What is owed is always non-empty, and a day page that
    // opened every morning with fifteen invoices on it would teach you to scroll past
    // the whole screen. The count and the link are the whole of it; מסך הכספים is where
    // that question is actually answered.
    // No heading of its own — a title over a one-line strip would make it look like the
    // fourth section, which is exactly what it is not.
    moneyOverdue: (n) => (n === 1 ? 'חשבונית אחת באיחור' : `${n} חשבוניות באיחור`),
    // The figures come from the office's whole book — the notification payload counts
    // overdue invoices without splitting them by issuing partner — so the strip says
    // whose they are rather than appearing to answer the filter above it.
    moneyBoth: 'של שני השותפים',
    goMoney: 'לכספים',

    // ── Empty ──────────────────────────────────────────────────────────────────────
    // ONE LINE PER SECTION, AND EVERY SECTION HAS ONE. The page has no single "nothing
    // today" state and deliberately so: four blocks that always appear, each saying which
    // kind of nothing it holds, is the only version in which an empty day is legible.
    // A missing section reads as a bug; a section saying "אין משימות להיום" reads as the
    // answer.
    //
    // Each has a שלי form, because they are DIFFERENT FACTS. "אין לידים לחזרה" says the
    // office has none; "אין לך לידים לחזרה" says the other partner may well have some,
    // and the filter above is what to change to see them.
    noMeetings: 'אין פגישות היום.',
    noMeetingsMine: 'אין לך פגישות היום.',
    noTasks: 'אין משימות להיום.',
    noTasksMine: 'אין לך משימות להיום.',
    noLeads: 'אין לידים לחזרה.',
    noLeadsMine: 'אין לך לידים לחזרה.',
    // The money strip's own good news. Not filtered and not per-partner, like the rest
    // of that line.
    noMoneyOverdue: 'אין חשבוניות באיחור.',
  },
};

export default myDay;
